// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"R4-z","displaySixCardTiles":"S4-z"};